import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class BusinessShopDistributeRecordAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getBusinessShopDistributeRecordList', {
      url: '/admin/poolRoomDistribute/list',
      name: 'list',
      label: '列表'
    }],
    ['addBusinessShopDistributeRecord', {
      url: '/admin/poolRoomDistribute/add',
      name: 'add',
      label: '添加'
    }],
    ['updateBusinessShopDistributeRecord', {
      url: '/admin/poolRoomDistribute/edit',
      name: 'edit',
      label: '编辑'
    }],

    ['exportExcelBusinessShopDistributeRecordList', {
        url: '/admin/poolRoomDistribute/export',
        name: 'export-excel',
        label: '导出'
    }],

    // ['getChooseOpenBusinessProcessList', {
    //   url: '/admin/opening/planAll',
    //   name: 'choose-open-business-porceess-list',
    //   label: '可选开业进度列表'
    // }],

    ['getOpenBusinessProcessCityList', {
      url: '/admin/poolRoomDistribute/area',
      name: 'open-business-city-list',
      label: '开业进度城市列表'
    }],
    // ['deleteBusinessShopDistributeRecord', {
    //   url: '/admin/operate_hint/delete',
    //   name: 'delete',
    //   label: '删除'
    // }],
    // ['searchVenueList', {
    //   url: '/admin/coupons/shop/list',
    //   name: 'shop-list',
    //   label: '店铺列表',
    //   // hidden: true
    // }],
   
  ])

  // 新厅开业进度列表
  public getBusinessShopDistributeRecordList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getBusinessShopDistributeRecordList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 修改新厅开业进度
  public updateBusinessShopDistributeRecord(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('updateBusinessShopDistributeRecord').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 添加新厅开业进度
  public addBusinessShopDistributeRecord(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('addBusinessShopDistributeRecord').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 导出开业进度列表
  public exportExcelBusinessShopDistributeRecordList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('exportExcelBusinessShopDistributeRecordList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 可选开业进度列表
  public getOpenBusinessProcessCityList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getOpenBusinessProcessCityList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 删除新厅开业进度
  // public deleteBusinessShopDistributeRecord(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('deleteBusinessShopDistributeRecord').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 搜索店铺列表
  // public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('searchVenueList').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  
}